import { render, staticRenderFns } from "./NewsletterRegistration.vue?vue&type=template&id=183c1fea&scoped=true"
import script from "./NewsletterRegistration.vue?vue&type=script&lang=js"
export * from "./NewsletterRegistration.vue?vue&type=script&lang=js"
import style0 from "./NewsletterRegistration.vue?vue&type=style&index=0&id=183c1fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183c1fea",
  null
  
)

export default component.exports